import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

// library
import { CodeInputComponent } from 'angular-code-input';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from '@ngx-translate/core';

// rxjs
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import 'rxjs/add/operator/map';

// services
import { DtoService, FunctService, UtilService, ApiTokenService } from "@services/index";
import { CommonService } from '@services/common.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-otp-page',
  templateUrl: './otp-page.component.html',
  styleUrls: ['./otp-page.component.scss']
})
export class OtpPageComponent implements OnInit {
  @ViewChild('codeInput') codeInput !: CodeInputComponent;
  isOtpService: boolean = false;
  OtpSms: any;
  otpcode: any;
  phoneNumber: any;
  time: number = 180;
  counterTimer: string | undefined;
  interval:  ReturnType<typeof setInterval> | undefined;
  otpPhoneNumber: any;
  actionType: any;// 'NEWDIVICE'
  updateDeviceId: any;
  deviceId: any;
  phone_no: any;
  ipAddress: any;
  guid: any;
  request_id: any;
  code: any;
  password: any; 
  token: any;
  checkOtpModel: any;
  parentLink: any;
  otpSettingAlert!: BsModalRef;
  @ViewChild('otpSettingAlert', {static: false})
  templatOtpSettingAlert!:  TemplateRef<any>;
  otpChannelList: any[] = [];
  selectedChannel: any={};
  @ViewChild('emailRef')
  emailRef!: NgModel;
  email: any= null;
  constructor(
    private route: ActivatedRoute,
    private apiTokenServer: ApiTokenService,
    private modalService: BsModalService, 
    private _service: CommonService,
    private translateService: TranslateService, 
    private toastr: ToastrService, 
    private spinner: NgxSpinnerService, 
    private dto: DtoService, 
    private http: HttpClient, 
    private util: UtilService,
    private router: Router, 
    private storage: LocalStorageService, 
    private funct: FunctService, 
     location: Location,) {
    this.route.queryParams.subscribe(params => { 
      this.actionType = params['type'];
    });
   
    this.parentLink = history.state.parentLink;
  
  }

  ngOnInit(): void {   
    this.startTimer();
    this.updateDeviceId = {
      deviceId: '',
      phone_no: '',
      ipAddress: '',
      guid: '',
      request_id: "0",
      code: '',
    }
    if (this.storage.retrieve('localNewDeviceOtpSms') != null) {
      if (this.storage.retrieve('localNewDeviceOtpSms').number != null) {
        this.phoneNumber = "+" + this.storage.retrieve('localNewDeviceOtpSms').number;
      };

    }
    if (this.storage.retrieve('localInsertAccountOtpSms') != null) {
      if (this.storage.retrieve('localInsertAccountOtpSms').number != null) {
        this.phoneNumber = "+" + this.storage.retrieve('localInsertAccountOtpSms').number;
      }
    }
    if (this.storage.retrieve('localPhoneValue') != null) {
      var prefix = this.storage.retrieve('localPhonePrefix');
      var phone = this.storage.retrieve('localPhoneValue');
      if (phone.startsWith('0')) {
        this.phoneNumber = prefix + phone.substring(1, phone.length);
      }
      else {
        this.phoneNumber = prefix + phone;
      }

    }
    this.checkOtpModel = {
      code: '',
      request_id: '',
      phone_no: '',
      register_key: ''
    }
  }

  startTimer() {
    if (this.interval) {
      clearInterval(this.interval);
     }
    this.interval = setInterval(() => {
      if (this.time > 0) {
        this.time--;
      } else {
        clearInterval(this.interval);
      }
      this.counterTimer = this.transform(this.time);
    }, 1000);
    return this.counterTimer;
  }
  transform(value: number): string {   
    const seconds: number = Math.floor(value);
    return '' + (value);
  }

  onCodeCompleted(i: number) {

    this.otpcode = i;
    this.validateOtp();

  }

  validateOtp() {
    const passErr = document.querySelector("#passErr") as HTMLElement;
    
    if (!this.otpcode || this.otpcode.length < 6) {
      passErr.innerHTML=this.translateService.instant("otp_required");
      return false;
    }
    else {
      passErr.innerHTML="";
      return true;
    }

  }

  checkOtp() {
    
    let checkOPTINput = this.validateOtp();
    if (!checkOPTINput) {
      return;
    }   
    if (this.actionType == "insertAccount") {
      
      if (this.storage.retrieve('localInsertAccountOtpSms').request_id != null) {

        this.token = this.storage.retrieve('token');
        let headers = new HttpHeaders();
        headers = headers.set('Authorization', this.token);
        this.OtpSms = [];
        this.http.get(this.funct.ipaddress + 'transaction/withdrawcheckOTP?code=' + this.otpcode + '&request_id=' + this.storage.retrieve('localInsertAccountOtpSms').request_id, { headers: headers })
          .pipe(
            catchError(this.handleError.bind(this))
          )
          .subscribe(
            result => {
              this.dto.Response = result;
              this.OtpSms = this.dto.Response;
              let bankList = this.storage.retrieve('localInsertBankBankAccount');
              bankList.otp_guid = result.otp_guid;
              console.log(bankList)
              this.storage.store('localInsertBankBankAccount', bankList);
              if (this.OtpSms != null) {
                if (this.OtpSms.status == true) {
                  this.router.navigate(['/wallet/withdraw'], { state: { otpSms: "insert" }, replaceUrl: true });
                  this.storage.clear('localInsertAccountOtpSms');
                  return true;
                } else {
                  this.toastr.error("Tip", 'OTP is not correct', {
                    timeOut: 3000,
                    positionClass: 'toast-top-center',
                  });//ShowError(context,Tran.of(context).text("sys_unauthrized"));
                  return false;
                }
              }
            }
          );

      }
      return
    }
 
    if (this.otpcode != null && this.otpcode.length == 6) {     
      
      if (this.storage.retrieve('localOtpSms') != null) {
        if (this.storage.retrieve('localOtpSms').request_id != null) {
          let headers = new HttpHeaders();
          this.OtpSms = [];

          this.checkOtpModel.code = this.otpcode;
          this.checkOtpModel.request_id = this.storage.retrieve('localOtpSms').request_id.toString();
          this.checkOtpModel.phone_no = this.storage.retrieve('localOtpSms').number;
          if (this.actionType == 'register') {
            this.checkOtpModel.register_key = this.funct.encrypt('checkForRegister');
          }
          else {
            this.checkOtpModel.register_key = '';
          }
          console.log(JSON.stringify(this.checkOtpModel))
          this.http.post(this.funct.ipaddress + 'user/checkOTP', this.checkOtpModel, { headers: headers })
            .pipe(
              catchError(this.handleError.bind(this))
            )
            .subscribe(
              result => {

                this.dto.Response = result;
                this.OtpSms = this.dto.Response;

                // console.log(JSON.stringify(this.OtpSms))

                if (this.OtpSms != null) {
                  if (this.OtpSms.status == true) {

                    if (this.actionType == "forgetPassword") {
                      this.storage.clear('localOtpSms');
                      this.router.navigate(['/account/resetPassword'], { state: { otp_guid: this.OtpSms.guid }, replaceUrl: true });

                    } else {
                      this.router.navigate(['/account/registration'], { replaceUrl: true });
                    }

                    return true;

                  } else {
                    this.toastr.error("Tip", 'OTP is not correct', {
                      timeOut: 3000,
                      positionClass: 'toast-top-center',
                    });
                    return false;
                  }
                }
              }
            );

        }

      }

    }
  }


  handleError(error: HttpErrorResponse) {

    //console.log(JSON.stringify(error))
    if (error.status == 0) {
      this.toastr.error("", 'check your internet connection', {
        timeOut: 3000,
        positionClass: 'toast-top-center',
      });
    }

    if (error.status == 409) {
      this.toastr.error(this.translateService.instant('record_alerady_exit'), "Please contact admin!", {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    if (error.status == 423) {
      this.toastr.error("", this.translateService.instant("youNeedLogin"), {
        timeOut: 3000,
        positionClass: 'toast-top-center',
      });
      this.storage.clear('token');
      this.storage.clear('isUserLoggedIn');
    }
    if (error.status == 406) {
      // phone number is taken
      this.toastr.error("Tip", this.translateService.instant('invalidotp'), {
        timeOut: 3000,
        positionClass: 'toast-bottom',
      });

      return false;
    } else if (error.status == 400) {
      // phone number is taken
      this.toastr.error("Tip", this.translateService.instant('invalidotp'), {
        timeOut: 3000,
        positionClass: 'toast-bottom-right',
      });

      return false;
    } 
    // else {
    //   this.toastr.error("Bad request.", 'OTP is not correct', {
    //     timeOut: 3000,
    //     positionClass: 'toast-top-center',
    //   });
    // }
    else{
      this.toastr.error("", error.error.message, {
        timeOut: 3000,
        positionClass: 'toast-top-right',
        });      
      return;
    }

  }
  ResendOtp(url) {

    let headers = new HttpHeaders();

    this.http.get(this.funct.ipaddress + url + this.phoneNumber+'&channel='+this.selectedChannel.channel_code, { headers: headers })
      .pipe(
        catchError(this.handleError.bind(this))
      )
      .subscribe(
        result => {
          this.dto.Response = {};
          this.dto.Response = result;
          //console.log("this.dto.Response>> " + JSON.stringify(this.dto.Response));     
          this.storage.store('localOtpSms', this.dto.Response);

          if (this.dto.Response.statusCode == 200) {
            if (this.dto.Response.body.split('').trim() == "Not valid OTP code") {
              this.toastr.error("Bad request.", 'OTP is not correct', {
                timeOut: 3000,
                positionClass: 'toast-top-center',
              });

              return null;
            }
            if (this.dto.Response.body.split('').trim() == "Try Again") {
              this.toastr.error("Bad request.", this.dto.Response.body.toString(), {
                timeOut: 3000,
                positionClass: 'toast-top-center',
              });
              return null;
            }
          }

        }
      );
  }
 
  ResendWithdrawOtp() {
    this.token = this.storage.retrieve('token');
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', this.token);
    //this.storage.retrieve('localInsertBankBankAccount'); //store for next otp page
    this.http.get(this.funct.ipaddress + 'transaction/getWithdrawOTP?channel='+this.selectedChannel.channel_code, { headers: headers })
      .pipe(
        catchError(this.handleError.bind(this))
      )
      .subscribe(
        result => {
          this.dto.Response = result;
          this.storage.store('localInsertAccountOtpSms', this.dto.Response);
        }
      );

  }

  openChannelListModal(template: TemplateRef<any>) {
    this.otpSettingAlert = this.modalService.show(template,
       {
          class: "otp-setting-modal modal-md"
        }
    );
  }

  closeChannelListModal() {
    this.otpSettingAlert.hide();
  }
   getOtpChannelList() {  
   
    this.apiTokenServer.getNotToken(`otpChannel/getOTPChannelByPhone?phone_no=${encodeURIComponent(this.phoneNumber)}`)
    .then(async (response: any)=> {         
      if(response.status == 200){       
        if(this.funct.fileName === "crazy"){
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].icon_url =  response.data[i].icon_url.replace('lucky2d', 'crazybossy');
          }
        }  
        console.log('OTP Channel List:', response);
        this.otpChannelList = response.data;
        for (let j = 0; j < response.data.length; j++) {
          if (response.data[j].is_default) {
            this.selectedChannel = response.data[j];
            break;
          }
        }
      }else{
         this.toastr.error("", response.data.message, {
          timeOut: 3000,
          positionClass: 'toast-top-center',
          });
          return;    
      }             
        
   })          
   .catch(async error=> {            
      this.toastr.error("", error.response?.data.message, {
          timeOut: 3000,
          positionClass: 'toast-top-center',
          });
        return;   
   });  
  }
  trackByOtpChannelList(index: number, item: any): number {
    return item.channel_id; 
  }
  onSelectOtpChannel(channel: any){
    this.selectedChannel = channel;   
  }
  checkEmail() { 
    if(this.email === null || this.email === undefined || this.email.trim() === ''){
      var required = this.translateService.instant("requiredFiled");
      required=required.toString().replace("{{value}}",  this.translateService.instant('email_address'));
      this.toastr.warning("", required, {
        timeOut: 3000,
        positionClass: 'toast-top-center',
      });
      
      return;
    }   
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var check = pattern.test(this.email);
    
    if(check){
      this.emailRef.control.setErrors(null);
    }else{
      this.emailRef.control.setErrors({ 'invalidEmail': true });
    }  
  }

  sendChannelByOtp() { 
    this.closeChannelListModal(); 
    if(this.actionType == 'NEWDIVICE') this.getNewOtp();
    else this.getOtp();
    //  if(this.selectedChannel.channel_code === 'EMAIL' && this.selectedChannel.destination === null && this.email == null){
    //   this.checkEmail();
    //   return;
    //  }
    //  if(this.email !== null && this.email !== undefined && this.email.trim() !== '') {
    //   this.selectedChannel.destination = this.email;
    //  }      
    //  var model= {
    //     phone_no: this.phoneNumber,
    //     is_default: true,
    //     channel_code: this.selectedChannel.channel_code,
    //     destination: this.selectedChannel.destination
    //   } 
      
    //   this.apiTokenServer.postNotToken(`userOtpSetting/insert`, model)
    //       .then(async (response: any)=>{
    //         console.log('Save OTP Setting Response:', response);
    //         if(response.status == 200){       
    //           this.toastr.success("", response.data.message, {
    //           timeOut: 3000,
    //           positionClass: 'toast-top-center',
    //           });
    //           this.getOtpChannelList();              
    //         }else{
    //           this.toastr.error("", response.data.message, {
    //           timeOut: 3000,
    //           positionClass: 'toast-top-center',
    //           });
    //           return; 
    //         }
    //       }).catch((err: any)=>{
    //           this.toastr.error("", err.response.data.message, {
    //           timeOut: 3000,
    //           positionClass: 'toast-top-center',
    //           });
    //           return; 
    //   });
  }
  
  showChannelList(){
    this.getOtpChannelList();
    this.openChannelListModal(this.templatOtpSettingAlert);
    
  }
   getOtp() {      
    this.time = 180;
    this.startTimer();
    if (this.actionType == "forgetPassword") {
      this.ResendOtp("user/getForgotPassowrdOTP?phoneNo=");
      return;
    }
    if (this.actionType == "insertAccount") {
      this.ResendWithdrawOtp();
      return;

    }
    else {
      this.ResendOtp("user/getRegisterOTP?phoneNo=");
      return;
    }


  }
  async getNewOtp() {   
    this.time = 180;
    this.startTimer();
    let headers = new HttpHeaders();
    this.http.get(this.funct.ipaddress + 'user/getRegisterDeviceOTP?phoneNo=' + this.phoneNumber+'&channel='+this.selectedChannel.channel_code, { headers: headers })
      .pipe(
        catchError(this.handleError.bind(this))
      )
      .subscribe(
        result => {
          this.dto.Response = result;
          this.storage.store('localNewDeviceOtpSms', this.dto.Response);
          if (this.dto.Response.statusCode == 200) {
            if (this.dto.Response.body.split('').trim() == "Not valid OTP code") {
              this.toastr.error("Bad request.", 'OTP is not correct', {
                timeOut: 3000,
                positionClass: 'toast-top-center',
              });

              return null;
            }
            if (this.dto.Response.body.split('').trim() == "Try Again") {
              this.toastr.error("Bad request.", this.dto.Response.body.toString(), {
                timeOut: 3000,
                positionClass: 'toast-top-center',
              });
              return null;
            }


          }

        }
      );
    return;
  }
  
  getNewDeviceOtp() {
   
    let headers = new HttpHeaders();
    this.updateDeviceId.phone_no = this.storage.retrieve('localLoginModel').phone_no;
    this.updateDeviceId.ipAddress = this.storage.retrieve('localLoginModel').ipAddress;
    this.updateDeviceId.guid = this.storage.retrieve('localNewDeviceOtpSms').guid;
    this.updateDeviceId.request_id = this.storage.retrieve('localNewDeviceOtpSms').request_id.toString();
    this.updateDeviceId.code = this.otpcode;
    this.updateDeviceId.deviceId = this.storage.retrieve('localLoginModel').deviceId;

    this.http.post(this.funct.ipaddress + 'user/updateDeviceId', this.updateDeviceId, { headers: headers })
      .pipe(
        catchError(this.handleError.bind(this))
      )
      .subscribe(
        result => {
          this.dto.Response = result;         
          if (this.dto.Response.status == "Success") {           
            this.storage.store('localErrorCode', 304);
            this.router.navigate(['/account/login'], { state: { errorCode: 304 }, replaceUrl: true });
            this.storage.clear('localNewDeviceOtpSms');
            return true;
          }
          else {
            this.toastr.error("Tip", this.dto.Response.message.toString(), {
              timeOut: 3000,
              positionClass: 'toast-top-center',
            });

            return false;
          }
          
        }
      );

  }

  goToServicePhone() {
     this.isOtpService = true;    
     //this.router.navigate(['/profile/otp-setting'], {  replaceUrl: false });

  }

  showOptPage(e: boolean) {
    this.isOtpService = e;
  }
}
